// General
import "./onboarding-diamonds-info-dialog.scss";
import { useState, useEffect, forwardRef } from "react";
// Services
import { sessionService } from "../../../../services/session.service";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateOnboardingDiamondsInfoDialog } from "../../../../redux/store/dialogStore";
// Material UI
import { Dialog, Slide, useMediaQuery } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// react-gtm-module
import TagManager from "react-gtm-module";
// i18next
import { useTranslation, Trans } from "react-i18next";
// Custom Hooks
import AssetManager from "../../../utility/manager/asset-manager/asset-manager";

const OnboardingDiamondsInfoDialog = () => {
  // General variables
  const [page, setPage] = useState(1);

  // Render variables
  let pageView;
  let titleView;
  let descriptionView;
  let backgroundImageView;

  // Redux variables
  const onboardingDiamondsInfoDialog = useSelector(
    (state) => state.dialog.onboardingDiamondsInfoDialog
  );
  const dispatch = useDispatch();

  // MUI variables
  const isMobile = useMediaQuery("(max-width: 720px)");

  // i18next variables
  const { t, i18n } = useTranslation();

  // Custom Hooks Functions
  const getAsset = AssetManager();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!onboardingDiamondsInfoDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-D7",
      },
    });
  }, [onboardingDiamondsInfoDialog]);

  // Event Handlers | Button
  const onPrevious = () => {
    setPage((prevPage) => {
      if (prevPage === 1) {
        return 1;
      }
      return prevPage - 1;
    });
  };
  const onNext = () => {
    setPage((prevPage) => {
      if (prevPage === 2) {
        return 2;
      }
      return prevPage + 1;
    });
  };

  // Event Handlers | MUI Dialog
  const onCloseDialog = (event, reason) => {
    if (reason === "backdropClick") return;

    // Save to local storage
    sessionService.setHasShownDiamondsInfoDialog(true);
    dispatch(updateOnboardingDiamondsInfoDialog(false));
  };

  // Render Functions
  switch (page) {
    case 1:
      pageView = <div className="page-container">{page}/2</div>;
      titleView = (
        <div className="live-title">
          <Trans i18nKey="onboarding.diamonds_title" />
        </div>
      );
      descriptionView = (
        <div className="live-description">
          <Trans i18nKey="onboarding.diamonds_desc" />
        </div>
      );
      backgroundImageView = (
        <img
          className="live-background"
          src={getAsset("diamondsIntro1Background")}
        />
      );
      break;
    case 2:
      pageView = <div className="page-container">{page}/2</div>;
      titleView = (
        <div className="live-title">
          <Trans i18nKey="onboarding.diamonds_into_cash_title" />
        </div>
      );
      descriptionView = (
        <div className="live-description">
          <Trans i18nKey="onboarding.diamonds_into_cash_desc" />
        </div>
      );
      backgroundImageView = (
        <img
          className="live-background"
          src={getAsset("diamondsIntro2Background")}
        />
      );
      break;
    default:
      break;
  }

  return (
    <Dialog
      className={
        isMobile ? "custom-dialog-transparent" : "custom-radius35-dialog"
      }
      fullScreen={isMobile ? true : false}
      open={onboardingDiamondsInfoDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <div
        id="onboarding-diamonds-info-dialog"
        className={isMobile ? "" : "max-width-container"}
      >
        <div className="header"></div>

        <div className="padding-container">
          {pageView}

          {titleView}

          {descriptionView}

          <div className="live-background-container">
            <div className="arrow-back-icon-container" onClick={onPrevious}>
              {page !== 1 && <ArrowBackIosIcon />}
            </div>
            {backgroundImageView}

            <div className="arrow-forward-icon-container" onClick={onNext}>
              {page !== 2 && <ArrowForwardIosIcon />}
            </div>
          </div>
        </div>

        {page === 2 && (
          <div className="footer">
            <div className="done-button" onClick={onCloseDialog}>
              {t("common.done")}
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default OnboardingDiamondsInfoDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
